import React from 'react';

import { CaretDownOutlined, CaretUpOutlined, SwapOutlined } from '@ant-design/icons';

const orderStrings = {
  asc: 'desc',
  desc: null,
  null: 'asc',
};

export const Order = ({ type, title, setOrder, order }) => {
  // Sıralama URL'de tutulur; yön sayfadan gelen `order`dan okunur ki yenileme ve geri tuşunda doğru kalsın.
  const currentOrder = order.type === type ? order.order : null;

  const handleClick = () => {
    setOrder({ type: type, order: orderStrings[currentOrder] });
  };

  return (
    <div
      style={{
        cursor: 'pointer',
        padding: '26px 9px',
        margin: '-26px -9px',
        background: order.type === type && currentOrder !== null && '#efefef',
      }}
      className="gx-text-center gx-d-flex gx-justify-content-between gx-align-items-center order-hover"
      onClick={() => handleClick()}
    >
      <div>{title}</div>
      <div>
        {order.type === type && currentOrder !== null ? (
          <span
            className="gx-m-1"
            style={{ color: '#3DA4E6' }}
          >
            {' '}
            {currentOrder === 'asc' ? <CaretDownOutlined /> : <CaretUpOutlined />}
          </span>
        ) : (
          <SwapOutlined
            className="gx-m-1"
            style={{ transform: 'rotate(90deg)' }}
          />
        )}
      </div>
    </div>
  );
};
